import React, { useContext, useState, useEffect } from "react";
import ReposContext from "../../../context/Repos";
import { Controlled as CodeMirror } from "react-codemirror2";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import "codemirror/mode/meta.js";

//import 'codemirror/keymap/sublime';
import 'codemirror/theme/monokai.css';
import 'codemirror/addon/display/autorefresh';
import 'codemirror/addon/comment/comment';
import 'codemirror/addon/edit/matchbrackets';

import { tags as t } from '@lezer/highlight';
import { aura, auraInit } from '@uiw/codemirror-theme-aura';


const modeList={"groovy": "groovy",
"ini": "properties",
"properties": "properties",
"css": "css",
"scss": "css",
"html": "htmlmixed",
"htm": "htmlmixed",
"shtm": "htmlmixed",
"shtml": "htmlmixed",
"xhtml": "htmlmixed",
"cfm": "htmlmixed",
"cfml": "htmlmixed",
"cfc": "htmlmixed",
"dhtml": "htmlmixed",
"xht": "htmlmixed",
"tpl": "htmlmixed",
"twig": "htmlmixed",
"hbs": "htmlmixed",
"handlebars": "htmlmixed",
"kit": "htmlmixed",
"jsp": "htmlmixed",
"aspx": "htmlmixed",
"ascx": "htmlmixed",
"asp": "htmlmixed",
"master": "htmlmixed",
"cshtml": "htmlmixed",
"vbhtml": "htmlmixed",
"ejs": "htmlembedded",
"dust": "htmlembedded",
"erb": "htmlembedded",
"js": "javascript",
"jsx": "javascript",
"jsm": "javascript",
"_js": "javascript",
"vbs": "vbscript",
"vb": "vb",
"json": "javascript",
"xml": "xml",
"svg": "xml",
"wxs": "xml",
"wxl": "xml",
"wsdl": "xml",
"rss": "xml",
"atom": "xml",
"rdf": "xml",
"xslt": "xml",
"xsl": "xml",
"xul": "xml",
"xbl": "xml",
"mathml": "xml",
"config": "xml",
"plist": "xml",
"xaml": "xml",
"php": "php",
"php3": "php",
"php4": "php",
"php5": "php",
"phtm": "php",
"phtml": "php",
"ctp": "php",
"c": "clike",
"h": "clike",
"i": "clike",
"cc": "clike",
"cp": "clike",
"cpp": "clike",
"c++": "clike",
"cxx": "clike",
"hh": "clike",
"hpp": "clike",
"hxx": "clike",
"h++": "clike",
"ii": "clike",
"ino": "clike",
"cs": "clike",
"asax": "clike",
"ashx": "clike",
"java": "clike",
"scala": "clike",
"sbt": "clike",
"coffee": "coffeescript",
"cf": "coffeescript",
"cson": "coffeescript",
"_coffee": "coffeescript",
"clj": "clojure",
"cljs": "clojure",
"cljx": "clojure",
"pl": "perl",
"pm": "perl",
"rb": "ruby",
"ru": "ruby",
"gemspec": "ruby",
"rake": "ruby",
"py": "python",
"pyw": "python",
"wsgi": "python",
"sass": "sass",
"lua": "lua",
"sql": "sql",
"diff": "diff",
"patch": "diff",
"md": "markdown",
"markdown": "markdown",
"mdown": "markdown",
"mkdn": "markdown",
"yaml": "yaml",
"yml": "yaml",
"hx": "haxe",
"sh": "shell",
"command": "shell",
"bash": "shell"}
const CodeEditor = ({ type }) => {
  //   const { currInputContent, currOutputContent } = useContext(ReposContext);

  //   return (
  //     <div className="code_editor">
  //       <pre>{type === "output" ? currOutputContent : currInputContent}</pre>
  //     </div>
  //   );
    
  const {
    currInputContent,
    currOutputContent,
    setCurrInputContent,
    setCurrOutputContent,
  } = useContext(ReposContext);


  const [inputCode, setInputCode] = useState("");
const [outputCode, setOutputCode] = useState("");

useEffect(()=>{
    setInputCode(currInputContent?.content);
    setOutputCode(currOutputContent?.content);
},[currInputContent,currOutputContent])

  const updateInputCode = (editor, data, value) => {
    console.log("value",value);
    setInputCode(value);
  };

  const updateOutputCode = (editor, data, value) => {
    console.log("value",value);
    setOutputCode(value);
  };

  const getMode = (codeContent) => {
    // Get the file extension from the content
    const fileExtension = codeContent.ext;
    console.log("codeContent",codeContent);
    console.log("fileExtension",fileExtension);
    const modeInfo=modeList[fileExtension];
    if (modeInfo) {
        console.log("modeInfo",modeInfo);
      return modeInfo;
    }
    console.log("modeInfo",modeInfo);
    // Default mode if no matching mode found
    //return "text/plain";
    return "js";
  };

  
  const modeType=getMode(type === "output" ? currOutputContent : currInputContent);
  console.log("modeType",modeType);
  let options = {
    lineNumbers: true,
    mode: modeType,
    theme: "material",
    lineWrapping: true,
  };
  console.log("currInputContent", currInputContent);
  console.log("currOutputContent", currOutputContent);

  return (
    <div>
      {type === "output" ? (
        <CodeMirror
          value={outputCode}
          onBeforeChange={updateOutputCode}
          options={options}
        />
      ) : (
        <CodeMirror
          value={inputCode}
          onBeforeChange={updateInputCode}
          options={options}
        />
      )}

    </div>
  );
};

export default CodeEditor;
